import { call } from 'redux-saga/effects';
import { Notifications } from 'types';
import { webSocketService } from 'services/WebSocketService';

export function* confirmResultSaga() {
  yield call(() => webSocketService.sendMessage({ type: Notifications.CONFIRM_RESULT }));
}
